import { useQuery } from '@apollo/client';
import { graphql } from '../gql';

export const GET_CLAIM_DATA = graphql(`
  query getClaimData($uuid: String) {
    claims(filters: { claimUuid: $uuid }) {
      edges {
        node {
          uuid
          claimVariant
          cryptoWalletId
          lengthOfDisruption
          recordsImpacted
          initialBudget

          numberOfEndpoints
          paid
          typePaid
          daysOccurrenceToDetection
          daysDetectionToContainment
          dataLoss
          initialDemand
          daysDetectionToForensicCompletion
          dataMined
          finalPayment
          rorSentDate
          ftfAmountOriginalLoss
          polSentDate
          ftfAmountRecovered
          becAccountsCompromised
          contributionFromOtherInsurance
          catCodeUuid
          threatActor {
            node {
              uuid
              name
            }
          }
        }
      }
    }
  }
`);

export interface IUseClaimDataQueryArg {
  claimUuid?: string;
}

export function useClaimDataQuery({ claimUuid }: IUseClaimDataQueryArg) {
  const { loading, data, error, refetch } = useQuery(GET_CLAIM_DATA, {
    variables: {
      uuid: claimUuid,
    },
    skip: !claimUuid,
    fetchPolicy: 'no-cache',
  });

  const claimData = data?.claims?.edges?.[0]?.node;

  return {
    loading,
    error,
    claimData,
    refetch,
  };
}
